/* eslint-disable no-console */
import { Component } from '@angular/core';
import type { OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {
    AccountsService, AccountProfileService, DateService, DealershipService, FirebaseFunctionsService, SummaryService
} from '@shared/services';
import { Constants } from '@shared/models';
const DateTimeFormats = Constants.DateTimeFormats;

@Component({
    'selector': 'app-tagAnalysis',
    'templateUrl': './tagAnalysis.page.html',
    'styleUrls': ['./tagAnalysis.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class TagAnalysisPage implements OnInit {
    public allAccounts: any = [];
    private signupDate: any;

    constructor(private accountsService: AccountsService, private accountProfileService: AccountProfileService,
        private summaryService: SummaryService, private firebaseFunctionsService: FirebaseFunctionsService,
        private dateService: DateService, private dealershipService: DealershipService) {
    }

    async ngOnInit() {
        const accounts: any = await this.accountsService.getAll();

        for (const account of accounts) {
            // The tableOfContents account is not a real account but a header record.  Skip it.
            if (account.uid === 'tableOfContents') {
                continue;
            }

            const accountObj = {
                'accountNumber': account.accountNumber,
                'profile': {},
                'summary': {},
                'tags': {}
            };

            const dealership = await this.dealershipService.getDealershipByAccountNumber(account.accountNumber);
            const profile = await this.accountProfileService.getAccountProfileByAccountNumber(account.accountNumber);
            this.signupDate = this.dateService.formatTimestamp(profile.signupDate, DateTimeFormats.Full);
            // const expirationDate = this.dateService.formatTimestamp(profile.periodInfo.expirationDate, DateTimeFormats.Full);

            accountObj.profile = {
                'dealershipName': dealership.dealershipName,
                'signupDate': this.dateService.formatTimestamp(profile.signupDate, DateTimeFormats.LongDate),
                'expirationDate': this.dateService.formatTimestamp(profile.periodInfo.expirationDate, DateTimeFormats.LongDate),
                'status': profile.status
            };

            const summary = await this.summaryService.getByAccountNumber(account.accountNumber);
            accountObj.summary = {
                // 'shuttlesDateInfo': this.computeDateInfo(summary.dataUsage.shuttles),
                'shuttlesCount': summary?.numShuttles,

                // 'usersDateInfo': this.computeDateInfo(summary.dataUsage.users),
                'usersCount': summary?.numUsers,

                // 'serviceAreasDateInfo': this.computeDateInfo(summary.dataUsage.serviceAreas),
                'serviceAreasCount': summary?.numServiceAreas,

                // 'ticketsDateInfo': this.computeDateInfo(summary.dataUsage.tickets),
                'ticketsCount': summary?.numTickets,

                // 'tripsDateInfo': this.computeDateInfo(summary.dataUsage.trips),
                'tripsCount': summary?.numTrips,

                // 'campaignsDateInfo': this.computeDateInfo(summary.dataUsage.campaigns),
                'campaignsCount': summary?.numCampaigns,
            };

            accountObj.tags = {
                'previous': 'users, settings',
                'suggested': 'tickets'
            };

            this.allAccounts.push(accountObj);
        }
        // this.accounts = accounts;
    }

    private computeDateInfo(summarySection: any) {
        const lastModifiedDate = summarySection.lastModifiedDate;
        const dt = this.dateService.formatTimestamp(lastModifiedDate, DateTimeFormats.SortDate2); //.format('MMM-DD');
        const daysAgo = this.signupDate.diff(lastModifiedDate, 'days') + ' days ago';
        const str = dt + '  -  ' + daysAgo;
        return str;

        // const daysAgo = this.dateService(summarySection.lastModifiedDate).diff(this.signupDate, 'days');
        // const duration = this.dateService.formatDuration(summarySection.lastModifiedDate, this.signupDate);
        // const daysAgo = this.dateService.formatDuration(duration);
        // return duration;
        // return '5 days';
    }

    public onAnalyzeClick() {
        console.log('Analyze clicked');
    }

    // public onListAllTagsClick() {
    //     this.firebaseFunctionsService.listAllTags();
    // }

    // public onActiveCampaignAddTagsClick() {
    //     const email = 'Michael@ShuttleNomix.com';

    //     const tagsToAdd: string[] = ['prospect', 'shuttle'];
    //     this.firebaseFunctionsService.adjustActiveCampaignTags(email, tagsToAdd, []);
    // }

    // public onActiveCampaignDeleteTagsClick() {
    //     const email = 'Michael@ShuttleNomix.com';
    //     const tagsToDelete: string[] = ['shuttle'];
    //     this.firebaseFunctionsService.adjustActiveCampaignTags(email, [], tagsToDelete);
    // }

    public onSaveClick() {
        console.log('Save clicked');
    }
}
